<template>
  <div :class="`diary ${css}`">
    <div class="row align-center">
      Agenda &nbsp;
      <i class="fa fa-question-circle font-13 tip">
        <div>Dias com risco vermelho são as Folgas.</div>
      </i>
      <div class="legend row align-center">
        <div class="square"></div> Dias Agendados
        <div class="disable"></div> Folgas
        <div class="days" v-if="form.dias_uteis_alocacao"><i class="fa fa-calendar-alt"></i> {{ form.dias_uteis_alocacao
          }} Dias</div>
        <div class="ml row align-center">Trabalha Sábado <input type="checkbox" @change="$emit('update',-1)" v-model="form.trabalha_sabado" /></div>
        <div class="ml row align-center">Trabalha Domingo <input type="checkbox" @change="$emit('update',-1)" v-model="form.trabalha_domingo" /></div>
      </div>
    </div>
    <br />
    <div class="row wrap text-center">
      <div v-for="(diary, i) of schedule" class="diary column" :key="'day' + i"
        @click="$emit('update', i)"
        :class="`${(diary.status == 'feriado' || diary.status == 'cancelado') && 'del'} pointer`">
        <div class="dayweek">{{ week[new Date(diary.dt_atendimento).getDay()] }}</div>
        <div class="day">{{ diary.dt_atendimento.slice(8, 10) }}</div>
        <div class="month">{{ month[new Date(diary.dt_atendimento).getMonth()] }}</div>
        <div class="year">{{ diary.dt_atendimento.slice(0, 4) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Diary",
  props: { form: Object, schedule: Array, css: String },
  components: {},
  data() {
    return {
      week: ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"],
      month: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"],
    };
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.diary
  input[type="checkbox"]
    width: 20px
    height: 20px
  .ml
    margin-left: 20px
  .legend
    font-size: 12px
    margin-left: 21px
    .square, .disable
      margin-right: 7px
      background: $purple
      width: 12px
      height: 20px
      border-radius: 6px
    .disable
        background: $red-1
        opacity: .7
        margin-left: 9px
    .days
      margin-left: 15px
      background: $purple
      color: white
      font-size: 20px
      padding: 4px
      border-radius: 4px
  .diary
    @include border
    margin: 6px 8px
    width: 70px
    padding: 6px 9px
    border-radius: 12px
    background: $purple
    color: white
    &.del,  &.feriado
      background: white
      color: $font-color
      &::before
       position: absolute
       content: "/"
       font-size: 130px
       color: $red-1
       margin-top: -9px
       margin-left:14px
       opacity: .7
       rotate: 19deg
    .dayweek
      font-size: 15px
      border-bottom: 1.3px solid #bbb
      padding-bottom: 6px
    .day
      font-size: 30px
      font-weight: bold
      margin-top: 6px
    .month
      font-size: 17px
      font-weight: bold
    .year
      font-size: 13px
      border-top: 1.3px solid #bbb
      padding-top: 6px
      margin-top: 6px
</style>
